









































































import Vue from "vue";
import AppLayout from "@/components/app-layout.vue";
import AppPerso from "@/components/app-prso.vue";
import InformationIndividu from "@/features/information/components/information-individu.vue";
import informationAutorisation from "@/features/information/components/information-autorisation.vue";
import informationParent from "@/features/information/components/information-parent.vue";
import informationSanitaire from "@/features/information/components/information-sanitaire.vue";
import informationChamp from "@/features/information/components/information-champ.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import moment from "moment";
import { Parent } from "../../models/Parent";
import { SHOW_LOADING, CLOSE_LOADING } from "@/store/types";
import { Autorisations } from "@/models/Autorisations";

export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    store.dispatch(SHOW_LOADING);
    store.dispatch("information/fetchInformations").then(function(rep: any) {
      store.dispatch(CLOSE_LOADING);
      next();
    });
  },
  components: {
    AppLayout,
    AppPerso,
    InformationIndividu,
    informationAutorisation,
    informationParent,
    informationSanitaire,
    informationChamp
  },
  computed: {
    ...mapGetters("individus", ["getIndividu"]),
    ...mapGetters("information", [
      "getInformationIndividu",
      "getChampLibreValeur",
      "getChampLibreResultValeur",
      "getChampsLibres",
      "getIndividuChamps",
      "getParents",
      "getMedecin",
      "getMaladies",
      "getAllergies",
      "getVaccins",
      "getFamilleChamps"
    ]),
    ...mapGetters("etablissements", ["getCurrentEtablissement"]),
    ...mapGetters("moncompte", ["getCurrentUser"]),
    familleIndInfos(){
      return this.getIndividu.getFamilleInfos();
    }
  },
  methods: {
    getAutoInd(): Array<Autorisations> {
      return this.getIndividu.getListeAutorisations();
    }
  }
});
